import React, { Component } from 'react'
// import { Link } from 'react-router-dom'
import { Layout } from 'antd'

const { Footer } = Layout

class FooterTmp extends Component {
  render() {
    return (
      <Footer style={{ textAlign: 'center', fontSize: '16px' }}>
        <a href="https://www.thai.run" target="_blank" rel="noopener noreferrer" >
            Powered by Thai.Run
        </a>
      </Footer>

    )
  }
}

export default FooterTmp



// WEBPACK FOOTER //
// ./src/Template/FooterTmp.js